import {HttpClient} from "../../service/httpClient/HttpClient";


export class ProfileService {


    constructor() {
        this.httpClient = new HttpClient()
    }


    getProfileDetail() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/own-information`
            ).then(resolve).catch(reject)
        })
    }
    getAvatarAdmin(){
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/avatars`
            ).then(resolve).catch(reject)
        })
    }

    updateProfileInfo(profileJsonInfo) {

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `admins`,
                profileJsonInfo,
            ).then(resolve).catch(reject)
        })

    }


    updateUserName(newUsername) {

        let formData = new URLSearchParams()
        formData.append("newUsername", newUsername)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/x-www-form-urlencoded"
            ).patch(
                `admins/username`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }

    changePassword(currentPassword, newPassword) {

        let formData = new URLSearchParams()
        formData.append("currentPassword", currentPassword)
        formData.append("newPassword", newPassword)

        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/x-www-form-urlencoded").put(
                `admins/password`,
                formData
            ).then(resolve).catch(reject)
        })
    }

    updateAdminAvatar(avatarFile) {
        return new Promise((resolve, reject) => {
            let data = new FormData()
            data.append('file', avatarFile)
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(`admins/avatars`,
                {}, data)
                .then(resolve).catch(reject)
        })
    }


}